import { useMemo } from 'react';
import { useUserStore } from '@Auth/store';
import { selectAssignableTeams } from '@helpers/teams';
import { teamQueries } from '@queries/fetchTeams';
import { useQuery } from '@tanstack/react-query';

export const useUserTeams = () => {
  const user = useUserStore(({ user }) => user);

  const shouldShowAllTeams = (user?.tenantIds?.length ?? 0) === 0;

  const allTeamsQuery = useQuery({ ...teamQueries.list(), enabled: shouldShowAllTeams });
  const userTeamsQuery = useQuery({ ...teamQueries.forUser(user?.tenantIds ?? []), enabled: !shouldShowAllTeams });

  const teams = shouldShowAllTeams ? allTeamsQuery.data : userTeamsQuery.data;
  const assignableTeams = useMemo(() => selectAssignableTeams(teams ?? []), [teams]);

  return {
    data: teams ?? [],
    assignableTeams,
    isFetching: shouldShowAllTeams ? allTeamsQuery.isFetching : userTeamsQuery.isFetching,
    isLoading: shouldShowAllTeams ? allTeamsQuery.isLoading : userTeamsQuery.isLoading,
  };
};
